import { Amplify, Auth } from 'aws-amplify';
import getToken from './services/TokenGetter';
import file from './amplifyconf.json';

// Custom config file for using Cognito via Amplify

// Add bearer token to request headers
const config = file;
const index = file.API.endpoints.findIndex((entry) => entry.name === 'REST');
config.API.endpoints[index] = {
  ...file.API.endpoints[index],
  custom_header: async () => (
    { Authorization: `Bearer ${getToken().toString()}` }
  ),
};

Amplify.configure(config);

export const currentConfig = Auth.configure();
